import { render, staticRenderFns } from "./JobFiles.htm?vue&type=template&id=2b40ecdd&scoped=true&"
import script from "./JobFiles.ts?vue&type=script&lang=js&"
export * from "./JobFiles.ts?vue&type=script&lang=js&"
import style0 from "./JobFiles.scss?vue&type=style&index=0&id=2b40ecdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b40ecdd",
  null
  
)

export default component.exports